import axios from "axios";

const http = axios.create({
    // baseURL: "http://localhost:8080/api",
    baseURL: "https://bhepl.com/api",
    headers: {
        "Content-type": "application/json",
    },
});

export default http;